// 歐克靈漂白水稀釋計算機｜Shopify 主題 asset
// 由 theme.liquid 條件載入，僅在 /pages/bleach-dilution-calculator 執行
// 2026-09-01｜公式：原液量 = 容器容量 ÷ 稀釋倍數（5% 原液，疾管署/衛福部標準）
(function () {
  'use strict';
  if (!document.getElementById('scenarioOpts')) return; // 頁面結構不存在則不執行

  var state = { ratio: 100, scenario: '一般環境消毒', volume: 1000 };

  function bindScenario() {
    var box = document.getElementById('scenarioOpts');
    if (!box) return;
    box.querySelectorAll('.opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.querySelectorAll('.opt').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.ratio = Number(btn.dataset.ratio);
        state.scenario = btn.dataset.scenario;
        render();
      });
    });
  }
  function bindVolume() {
    var box = document.getElementById('volumeOpts');
    if (!box) return;
    box.querySelectorAll('.opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.querySelectorAll('.opt').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.volume = Number(btn.dataset.vol);
        render();
      });
    });
  }
  bindScenario();
  bindVolume();

  var customVol = document.getElementById('customVol');
  if (customVol) customVol.addEventListener('input', function (e) {
    var v = Number(e.target.value);
    if (v > 0) {
      state.volume = v;
      document.querySelectorAll('#volumeOpts .opt').forEach(function (b) { b.classList.remove('active'); });
      render();
    }
  });

  // 計算：原液量 = 容器容量 ÷ 稀釋倍數（5% 原液）
  function render() {
    var stock = Math.round(state.volume / state.ratio);
    var capTip = Math.max(1, Math.round(stock / 5)); // 1 瓶蓋≈5ml（家用漂白水瓶蓋標準）
    document.getElementById('resVolume').textContent = state.volume;
    document.getElementById('resScenario').textContent = state.scenario;
    document.getElementById('resRatio').textContent = state.ratio;
    document.getElementById('resStock').textContent = stock;
    document.getElementById('resTip').textContent = '約 ' + capTip + ' 瓶蓋（1 瓶蓋≈5ml）';
  }

  function copyResult() {
    var stock = Math.round(state.volume / state.ratio);
    var capTip = Math.max(1, Math.round(stock / 5));
    var text = '漂白水消毒液調配：5% 原液、' + state.volume + 'ml 容器、' + state.scenario + '（稀釋 ' + state.ratio +
      ' 倍）→ 加 ' + stock + 'ml 漂白水原液並將容器加滿（約 ' + capTip + ' 瓶蓋）';
    if (navigator.clipboard) navigator.clipboard.writeText(text);
    alert('✅ 配方已複製！可以貼到 Line 分享');
  }
  function shareResult() {
    var stock = Math.round(state.volume / state.ratio);
    var text = encodeURIComponent('漂白水消毒液 ' + state.ratio + ' 倍配方：' + state.volume +
      'ml 容器加 ' + stock + 'ml 5% 漂白水＋水');
    if (navigator.share) navigator.share({ text: decodeURIComponent(text) });
    else { window.open('https://line.me/R/msg/text/?' + text, '_blank'); }
  }

  var copyBtn = document.getElementById('copyBtn');
  var shareBtn = document.getElementById('shareBtn');
  if (copyBtn) copyBtn.addEventListener('click', copyResult);
  if (shareBtn) shareBtn.addEventListener('click', shareResult);

  render();
})();
